// extracted by mini-css-extract-plugin
export default {"advertising":"AdvertisingBlock_advertising__3svml"};